<!--FEEDBACK SECTION-->
<section class="feedback-container" *ngIf="!isAiEssentialsPage">
  <div class="wrapper">
    <!--FEEDBACK SECTION FOR VOUCHER PAGE-->
    <div *ngIf="isVoucherPage; else innerSection">
      <div class="inner-feedback-section padding-top-small padding-bottom-small">
        <!--FEEDBACK ICON-->
        <div class="margin-right-small">
          <i class="icon red chat medium"></i>
        </div>
        <!--END FEEDBACK ICON-->
        <span class="feedback-voucher">
          <h4>
            <strong>{{ 'FEEDBACK.NEED_ASSISTANCE' | translate }}</strong>
          </h4>
          {{ 'FEEDBACK.HELP_TEXT' | translate }}
          <a class="gen-primary-link--accesible with-underline" href="mailto:education@genesys.com">
            education&#64;genesys.com
          </a>
          {{ 'FEEDBACK.VOUCHER_CODE_TEXT' | translate }}
        </span>
        <!--END SUPPORT BEYOND EMAIL-->
      </div>
    </div>
    <!--END FEEDBACK SECTION FOR VOUCHER PAGE-->
    <ng-template #innerSection>
      <!--FEEDBACK SECTION FOR INNERSECTION-->
      <div class="inner-feedback-section padding-top-small padding-bottom-small">
        <!--FEEDBACK ICON-->
        <div class="margin-right-small">
          <i class="icon red chat medium"></i>
        </div>
        <!--END FEEDBACK ICON-->
        <!--SUPPORT BEYOND EMAIL-->
        <div class="feedback-text">
          <span class="feedback-help">
            Need help with your account or accessing your learning subscription content? Click on
            the Chatbot below.
          </span>
        </div>
        <!--END SUPPORT BEYOND EMAIL-->
      </div>
      <!--END FEEDBACK SECTION FOR INNERSECTION-->
    </ng-template>
  </div>
</section>
<!--END FEEDBACK SECTION-->
